import { useState } from "react";
import type { FaqItem } from "@/mocks/site";

export default function FaqAccordion({
  items,
  defaultOpenId,
}: {
  items: FaqItem[];
  defaultOpenId?: string;
}) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                aria-controls={`${item.id}-panel`}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.question}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md text-lg transition-colors ${
                    isOpen
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-500"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div id={`${item.id}-panel`} className="pb-5 pr-10">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}